/**
 * Provider onboarding: section keys and state types.
 */

export const ONBOARDING_SECTION_IDS = [
  'personal-info',
  'availability',
  'profile',
  'licenses-education',
  'attestation',
] as const;

export type OnboardingSectionId = (typeof ONBOARDING_SECTION_IDS)[number];

export const REQUIRED_SECTIONS: OnboardingSectionId[] = [
  'personal-info',
  'availability',
  'profile',
  'licenses-education',
  'attestation',
];

export interface OnboardingSectionDef {
  id: OnboardingSectionId;
  path: string;
  title: string;
  description: string;
  required: boolean;
}

export const ONBOARDING_SECTIONS: OnboardingSectionDef[] = [
  {
    id: 'personal-info',
    path: '/onboarding/personal-info',
    title: 'Personal Information',
    description: 'Name, NPI, home address, headshot, and driver\'s license',
    required: true,
  },
  {
    id: 'availability',
    path: '/onboarding/availability',
    title: 'Availability',
    description: 'Weekly working hours for client booking',
    required: true,
  },
  {
    id: 'profile',
    path: '/onboarding/profile',
    title: 'Profile',
    description: 'Specialties, modalities, age groups, and demographics',
    required: true,
  },
  {
    id: 'licenses-education',
    path: '/onboarding/licenses-education',
    title: 'Licenses and Education',
    description: 'Education, licenses, certifications, training, and CAQH',
    required: true,
  },
  {
    id: 'attestation',
    path: '/onboarding/attestation',
    title: 'Attestation',
    description: 'Sign to confirm all information is accurate',
    required: true,
  },
];
